export const CategorySections = ['WOMEN', 'MEN', 'BG'];

// compact-mode: backgrond white, black letters
// phantom-white: backgrond transparent, black letters
// phantom-dark: backgrond transparent, white letters
export enum StyleHeaderEnum {
    COMPACT = 'compact-mode',
    PHANTOM_WHITE = 'phantom-white',
    PHANTOM_WHITE_GRADIENT = 'phantom-white-gradient',
    PHANTOM_DARK = 'phantom-dark',
    BLEND = 'blend-mode',
}
